import React from 'react';
import DataList from '../DataList';
import { getContacts, deleteContact, bulkDeleteContacts, bulkUploadContacts } from '../../api/data';

const ContactsList: React.FC = () => {
  const config = {
    title: 'Contacts',
    singularName: 'contact',
    columns: [
      { key: 'id', label: 'ID' },
      { key: 'unit', label: 'Unit' },
      { key: 'name_ar', label: 'Arabic Name' },
      { key: 'name_en', label: 'English Name' },
      { key: 'phone', label: 'Phone' },
      { key: 'email', label: 'Email' }
    ],
    fetchData: getContacts,
    deleteItem: deleteContact,
    bulkDelete: bulkDeleteContacts,
    bulkUpload: bulkUploadContacts,
    createRoute: '/data/contacts/create',
    editRoute: (id: number) => `/data/contacts/${id}/edit`
  };

  return <DataList config={config} />;
};

export default ContactsList;
